<template><div class="ai-component-body">
        <h3>{{ displayCard.title }}</h3>
        <div class="ai-device-group" :class="{ 'is-scrolled': hasDeviceScrolled }" :style="{ '--device-columns': deviceColumns }">
          <ai-list-surface :scrolled="hasDeviceScrolled">
          <div ref="deviceScroll" class="ai-device-scroll ai-list-scroll" :class="{ 'is-scrollable': hasDeviceOverflow }" tabindex="0" role="region" aria-label="设备列表，可上下滚动" @scroll.passive="measureDeviceOverflow(); loadDevicesOnScroll()">
            <div ref="deviceGrid" class="ai-manual-grid"><div v-for="item in displayCard.items" :key="[item.ref.regionId,item.ref.productId,item.ref.deviceId].join('|')" class="ai-device-frame"><ai-manual-device :item="item" :busy="manualDisabled || deviceLoading" /></div></div>
            <p v-if="!displayCard.items.length && !deviceLoading && !deviceError" class="ai-device-empty">{{ displayCard.emptyText }}</p>
          </div>
          </ai-list-surface>
          <ai-list-footer :summary="displayCard.footerText" :notice="listNotice(displayCard, devicePagination)" :loading="devicePagination.loading" :error="devicePagination.error"
            :has-more="displayCard.hasMore" :overflow="hasDeviceOverflow" :busy="busy" @more="requestDevicePage(true)" />
        </div>

      </div></template>
<script>
import scrollbarBehavior from '@/ai/components/mixins/scrollbar-behavior'
import behavior from '@/ai/components/mixins/device-behavior'
import deviceList from './mixins/device-list-state'
import AiListSurface from './AiListSurface.vue'
import AiListFooter from './AiListFooter.vue'
export default { components: { AiListFooter, AiListSurface }, mixins: [behavior, scrollbarBehavior, deviceList] }
</script>
<style scoped src="./cards.css"></style>
<style scoped src="./surfaces.css"></style>
<style scoped>
/* 布局与模板同文件维护。根节点必须有布局盒，ResizeObserver才能测量真实宽度。 */
.ai-component-body { display: block; min-width: 0; width: 100%; }
.ai-device-group { width:100%;min-width:0; }
.ai-device-scroll { max-height:248px; }
.ai-manual-grid { display: grid; grid-template-columns: repeat(var(--device-columns, 1), minmax(0, 180px)); gap: 10px; }
.ai-manual-grid > * { min-width: 0; }
/* AI外包装仅承载网格，不附加描边或阴影，保留原卡片边缘和弹窗定位。 */
.ai-device-frame { border-radius: 14px;  }
.ai-load-devices { border: 0; padding: 0; background: transparent; color: #174b91; font: inherit; cursor: pointer; }
.ai-device-empty { margin: 8px 0; color: #293e5b; font-size: 12px; }
</style>
